const INITIAL_DATA = {
    authToken: localStorage.getItem("authToken") || false,
    me: {
        __typename: 'User'
    }
};

export default INITIAL_DATA;